import { LatLong } from '../../types';

export const getBrowserGeoLocation = (): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};

export async function getLatLong(): Promise<LatLong> {
  if (!navigator.geolocation) {
    throw new Error('Can not use geolocation');
  }
  const coords = (await getBrowserGeoLocation())?.coords;
  return { lat: coords?.latitude, lng: coords?.longitude };
}
